import { COLOR, FIXED_INDENTS, FONTS, INDENTS } from 'vars/index'

export const DropdownItemFonts = {
  Body4: FONTS.Body4,
  Body3: FONTS.Body3,
  Caption4: FONTS.Caption4,
  Button2: FONTS.Button2,
  FontSm: FONTS.FontSm,
  FontSmBold: FONTS.FontSmBold,
  FontXs: FONTS.FontXs,
} as const
export type DropdownItemFonts =
  (typeof DropdownItemFonts)[keyof typeof DropdownItemFonts]

export const DropdownItemFontColors = {
  TEXT_ICON_PRIMARY: COLOR.TEXT_ICON_PRIMARY,
  TEXT_ICON_SECONDARY: COLOR.TEXT_ICON_SECONDARY,
  TEXT_ICON_TERTIARY: COLOR.TEXT_ICON_TERTIARY,
  SURFACE_LIGHT_2: COLOR.SURFACE_LIGHT_2,
  BASE_MAIN_PRESSED: COLOR.BASE_MAIN_PRESSED,
  SURFACE_DARK_7: COLOR.SURFACE_DARK_7,
  TEXT_ICON_CONSTANT_LIGHT: COLOR.TEXT_ICON_CONSTANT_LIGHT,
  ACCENT_TERTIARY: COLOR.ACCENT_TERTIARY,
} as const
export type DropdownItemFontColors =
  (typeof DropdownItemFontColors)[keyof typeof DropdownItemFontColors]

export const DropdownItemBackgrounds = {
  TRANSPARENT: COLOR.TRANSPARENT,
  SURFACE_OPACITY_LIGHT_10: COLOR.SURFACE_OPACITY_LIGHT_10,
  SURFACE_OPACITY_LIGHT_15: COLOR.SURFACE_OPACITY_LIGHT_15,
  SURFACE_OPACITY_LIGHT_20: COLOR.SURFACE_OPACITY_LIGHT_20,
  TEXT_ICON_TERTIARY: COLOR.TEXT_ICON_TERTIARY,
} as const
export type DropdownItemBackgrounds =
  (typeof DropdownItemBackgrounds)[keyof typeof DropdownItemBackgrounds]

export const DropdownItemColumnGap = {
  INDENT_0: FIXED_INDENTS.INDENT_0,
  INDENT_20: FIXED_INDENTS.INDENT_20,
  INDENT_40: FIXED_INDENTS.INDENT_40,
} as const
export type DropdownItemColumnGap =
  (typeof DropdownItemColumnGap)[keyof typeof DropdownItemColumnGap]

export const DropdownItemPaddings = {
  SIZE_0: [
    INDENTS.INDENT_0,
    INDENTS.INDENT_0,
    INDENTS.INDENT_0,
    INDENTS.INDENT_0,
  ],
  SIZE_10: [
    FIXED_INDENTS.INDENT_20,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_20,
    FIXED_INDENTS.INDENT_40,
  ],
  SIZE_20: [
    INDENTS.INDENT_20,
    INDENTS.INDENT_60,
    INDENTS.INDENT_20,
    INDENTS.INDENT_60,
  ],
  SIZE_30: [
    INDENTS.INDENT_5,
    INDENTS.INDENT_40,
    INDENTS.INDENT_5,
    INDENTS.INDENT_40,
  ],
  SIZE_40: [
    INDENTS.INDENT_20,
    INDENTS.INDENT_55,
    INDENTS.INDENT_20,
    INDENTS.INDENT_55,
  ],
  SIZE_50: [
    FIXED_INDENTS.INDENT_30,
    FIXED_INDENTS.INDENT_60,
    FIXED_INDENTS.INDENT_30,
    FIXED_INDENTS.INDENT_60,
  ],
  SIZE_60: [
    FIXED_INDENTS.INDENT_30,
    FIXED_INDENTS.INDENT_40,
    FIXED_INDENTS.INDENT_30,
    FIXED_INDENTS.INDENT_40,
  ],
}

export type DropdownItemPadding =
  (typeof DropdownItemPaddings)[keyof typeof DropdownItemPaddings]
